import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import OrganizationApiService from './OrganizationApiService';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';
import { GET_BRANCH_DROP_DOWN_LIST } from 'Store/Organization/Branch/BranchType';
import { setBranchDropDown } from 'Store/Organization/Branch/BranchAction';

function* getBranchList(req: any): any {
    try {
        yield put(globalLoaderText("Fetching Dropdown Data...."));
        let payloadData: IPayload = {
            apiType: apiType.Organization,
            endpoint: `organizations/dropdown/branch/${req.marketId}`,
            apiMethod: apiMethod.GET,
            payload: null

        }
        const response = yield call(
            OrganizationApiService.post, API_URL.PostWebApp, payloadData
        );
        yield put(setBranchDropDown(response));
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setBranchDropDown([]));
        yield put(globalLoaderText(""));
    }
}

function* watchGetBranchDropDowns() {
    yield takeEvery(GET_BRANCH_DROP_DOWN_LIST, getBranchList)
}

export default function* combinedSaga() {
    yield all([
        watchGetBranchDropDowns()
    ])
}
